<template>
  <div class="list-head">
    <div class="header-wrap header-public clearfix">
      <div class="header-left cleearfix">
        <i class="icon-czur-logo"></i>
        <div class="header-function">
          <div class="function-bar">
            <span>ET</span>
            <i class="icon-down-arrow"></i>
          </div>
          <div class="function-list">
            <div class="function-li active" @click="changeActiveProduct('index.html#/et')">
              <img class="function-li-img" src="../../assets/images/et_nav.png" alt="">
              <div class="function-li-title">ET</div>
            </div>
            <div class="function-li" @click="changeActiveProduct('index.html#/notebook')">
              <img class="function-li-img" src="../../assets/images/notebook_nav.png" alt="">
              <div class="function-li-title">{{$t('index.notebook')}}</div>
            </div>
<!--             <div class="function-li" @click="changeActiveProduct('starry.html#/starry/cloudSynchronizationFile/all')">
              <img class="function-li-img" src="../../assets/images/starry_nav.png" alt="">
              <div class="function-li-title">投影仪</div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="nav" :class="{'time': mode == 0, 'folder': mode == 1, 'pdf': mode == 2}">
        <div class="nav-li" :class="{'active': mode == 0}" @click="modeChange(0)">
          {{$t('list.time')}}
          <div class="nav-active"></div>
        </div>
        <div class="nav-li" :class="{'active': mode == 1}" @click="modeChange(1)">
          {{$t('list.category')}}
          <div class="nav-active"></div>
        </div>
        <div class="nav-li" :class="{'active': mode == 2, 'disable': pdfDisable}" @click="modeChange(2)">
          PDF
          <div class="nav-active"></div>
        </div>
      </div>
      <div class="header-right clearfix">
        <div class="scanner-wrap" @mouseover="createDevicesTimer" @mouseout="clearTimer">
          <i class="icon-list"></i>
          <div class="scanner-list">
            <div class="scanner-list-th clearfix">
              <span class="scannerr-th-t">{{$t('device.deviceList')}}</span>
              <i class="icon-add" @click="addDevice('addDevice')"></i>
            </div>
            <div class="scanner-list-li clearfix" :class="{'scanner-list-li-bg': deviceIndex % 2 !== 0, 'active': device.bindUserId === Number(uId)}" v-for="(device, deviceIndex) in devices" :key="deviceIndex">
              <span class="scanner-name">{{device.alias}}</span>
              <i class="icon-set" @click="showDeviceManagementPop(deviceIndex)"></i>
              <button class="scanner-btn" :class="{'btn-red': device.needUpdateFw}" @click="requestUse(deviceIndex)" v-if="device.needUpdateFw">{{device.usingMsg}}</button>
              <button class="scanner-btn" :class="{'btn-black': !device.isInUsing, 'btn-grey': device.isInUsing}" v-if="!device.needUpdateFw && device.isShared" @click="requestUse(deviceIndex)">{{device.usingMsg}}</button>
            </div>
            <div class="no-device" v-if="showNoDevice">
              <div class="no-device-main">
                <img src="../../assets/images/no_device.png" alt="">
                <div>{{$t('device.noDevice')}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="user-informations clearfix">
          <img class="header-img" v-if="defaultHeaderImg" src="../../assets/images/default_header_img.png" alt="">
          <img class="header-img" v-if="!defaultHeaderImg" :src="src" alt="">
          <div class="user-wrap">
            <div class="user-name-wrap">
              <span class="user-name">{{userName}}</span>
              <i class="icon-down-arrow"></i>
            </div>
            <div class="user-list">
              <a class="user-list-li" @click="goPersonalInformation">{{$t('list.accountCenter')}}</a>
              <a class="user-list-li" @click="exit">{{$t('list.logOut')}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HttpClient from 'common/script/http'
import * as Config from 'common/script/config'
import Device from 'common/model/Device'
import Validate from 'common/script/validate'
export default {
  name: 'listHead',
  props: ['selectedNum', 'mode'],
  data () {
    return {
      defaultHeaderImg: true,
      src: '',
      userName: '',
      devices: [],
      showNoDevice: false,
      devicesTimer: null,
      pdfDisable: true,
      uId: Config.cookieGet(Config.COOKIE_KEY.U_ID),
      email: '',
      initialise: true
    }
  },
  created () {
    this.checkPdfStatus()
    this.getUserInfo()
    this.getDeviceList()
  },
  mounted () {
    window.addEventListener('hashchange', this.hashchange)
  },
  methods: {
    hashchange: function () {
      location.reload()
    },
    changeActiveProduct: function (val) {
      window.location.href = val
    },
    requestUse: function (index) {
      if (this.devices[index].needUpdateFw) {
        this.addDevice('upgradePrompt')
      } else {
        if (!this.devices[index].isInUsing) {
          HttpClient.getData(Config.APP_HOST + '/v1/device/apply/using/' + this.devices[index].id + '?u_id=' + this.uId).then((response) => {
            this.getDeviceList()
          })
        } else {
          // console.log(this.devices[index].inUsingUserInfo)
          this.addDevice('isInUsingTips', this.devices[index].inUsingUserInfo)
        }
      }
    },
    showDeviceManagementPop: function (index) {
      const deviceId = this.devices[index].id
      const deviceName = this.devices[index].alias
      const bindUserId = this.devices[index].bindUserId
      const deviceType = this.devices[index].type
      const deviceIsPublic = this.devices[index].isPublic
      this.$emit('showDeviceManagementPop', deviceId, deviceName, bindUserId, deviceType, deviceIsPublic)
    },
    addDevice: function (val, inUsingUserInfo) {
      this.$emit('addDevice', val, inUsingUserInfo)
    },
    closeSelected: function () {
      this.$emit('closeSelected')
    },
    goPersonalInformation: function () {
      var url = Config.PASSPORT_HOST + '/basic.html?token=' + Config.cookieGet(Config.COOKIE_KEY.TOKEN) + '&u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID) + '&Channel=' + Config.CHANNEL + '&lang=' + Validate.lang() + '#/baiscPage'
      window.open(url, '_blank')
    },
    exit: function () {
      HttpClient.getData(Config.APP_HOST + '/v1/user/logout').then((response) => {
        Config.cookieSet(Config.COOKIE_KEY.U_ID, '')
        Config.cookieSet(Config.COOKIE_KEY.TOKEN, '')
        Config.cookieSet(Config.COOKIE_KEY.USER_NAME, '')
        window.location.href = '/?action=logout' // &callback=' + encodeURIComponent(window.location)
      })
    },
    modeChange: function (val) {
      this.$emit('modeChange', val)
    },
    createDevicesTimer: function () {
      if (this.devicesTimer === null) {
        var thisObj = this
        this.devicesTimer = setInterval(function () {
          thisObj.getDeviceList()
        }, 1000)
      }
    },
    clearTimer: function () {
      clearInterval(this.devicesTimer)
      this.devicesTimer = null
    },
    openPdfMode: function () {
      this.pdfDisable = false
    },
    checkPdfStatus: function () {
      HttpClient.getData(Config.APP_HOST + '/v2/pdf/time?u_id=' + this.uId, this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          if (response.body.length > 0) {
            this.pdfDisable = false
          } else {
            if (this.mode === 2) {
              this.$router.push('/et/time')
            }
          }
        }
      })
    },
    getUserInfo: function () {
      HttpClient.getData(Config.APP_HOST + '/v1/user/info?u_id=' + this.uId, this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          if (response.body.photo) {
            this.defaultHeaderImg = false
            this.src = response.body.photo
          }
          this.userName = response.body.name
          this.email = response.body.email
          this.$emit('getUserInfo', this.userName, this.email)
        }
      })
    },
    getDeviceList: function () {
      HttpClient.getData(Config.APP_HOST + '/v1/device/list?u_id=' + this.uId, this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          // console.log(response.body)
          this.devices = []
          for (var i = 0; i < response.body.length; i++) {
            var scanner = new Device()
            scanner.loadData(response.body[i], this.uId)
            this.devices.push(scanner)
            if (scanner.needUpdateFw) {
              scanner.usingMsg = this.$t('device.needFirmwareUpgrade')
              if (this.initialise) {
                this.addDevice('upgradePrompt')
                this.initialise = false
              }
            } else {
              if (scanner.isInUsing) {
                scanner.usingMsg = this.$t('device.using')
                if (scanner.inUsingUserId === Number(this.uId)) {
                  scanner.usingMsg = this.$t('device.using')
                }
              } else {
                scanner.usingMsg = this.$t('device.apply')
              }
            }
          }
          // 如果没有设备
          if (this.devices.length <= 0) {
            this.showNoDevice = true
          } else {
            this.showNoDevice = false
          }
        }
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.list-head
  width 100%
  height 50px
  line-height 50px
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  color #3d3d3d
  z-index 99
  .header-wrap
    &.header-public
      width 100%
      height 100%
      background-color #fff
      border-bottom 1px solid #ebebeb
      font-size 14px
      display block
      position relative
      .header-left
        float left
        .icon-czur-logo
          float left
          margin 14px 34px 14px 20px
          font-size 22px
          color #3d3d3d
        .header-function
          float left
          width 83px
          &:hover
            .function-list
              display block
          .function-bar
            text-align left
            .icon-down-arrow
              vertical-align middle
          .function-list
            width 292px
            height 128px
            border 1px solid #e9e9e9
            margin-top -10px
            background-color #fff
            position absolute
            left 20px
            display none
            .function-li
              display inline-block
              width 70px
              margin 19px 22px 10px 22px
              cursor pointer
              .function-li-img
                display block
                margin-bottom 9px
              .function-li-title
                font-size 12px
                width 62px
                height 18px
                line-height 18px
                margin-left 4px
                border 1px solid transparent
                border-radius 10px
              &.active
                .function-li-title
                  color rgba(9, 130, 203, 0.5)
                  border-color rgba(9, 130, 203, 0.5)
                  background-color #f5fbff
      .nav
        position relative
        display inline-block
        color #9b9b9b
        .nav-li
          display inline-block
          width 70px
          margin 0 5px
          cursor pointer
          position relative
          .nav-active
            position absolute
            width 20px
            height 2px
            background-color #3d3d3d
            left 50%
            bottom 0px
            margin-left -10px
            transition all 0.2s ease-in
            opacity 0
          &.active
            color #3d3d3d
            .nav-active
              opacity 1
          &:hover
            color #3d3d3d
          &.disable
            display none
      .header-right
        float right
        .user-informations
          float right
          width 154px
          height 32px
          margin 9px 0
          .header-img
            float left
            width 32px
            height 32px
            margin-right 10px
            border-radius 50%
          .user-wrap
            float left
            width 110px
            height 100%
            line-height 32px
            position relative
            text-align left
            &:hover
              .user-name-wrap
                .icon-down-arrow
                  animation rotate .5s
              .user-list
                display block
            .user-name-wrap
              cursor pointer
              .user-name
                display inline-block
                max-width 90px
                height 18px
                line-height 18px
                white-space nowrap
                text-overflow ellipsis
                overflow hidden
                vertical-align middle
              .icon-down-arrow
                font-size 12px
                vertical-align text-bottom
            .user-list
              display none
              width 108px
              height 60px
              position absolute
              top 30px
              right 0
              padding 6px 0px
              background-color #fff
              font-size 12px
              border 1px solid #f2f2f2
              border-radius 4px
              .user-list-li
                display block
                height 30px
                line-height 30px
                text-align center
                cursor pointer
        .scanner-wrap
          float right
          padding 17px 20px 17px 20px
          line-height 12px
          margin-left 10px
          .icon-list
            font-size 16px
            cursor pointer
          .scanner-list
            width 262px
            height 100%
            position fixed
            right -263px
            /*right 0*/
            top 50px
            background-color #fff
            border-left 1px solid #f1f1f1
            padding-top 40px
            box-sizing border-box
            .scanner-list-th
              display block
              width 100%
              height 40px
              line-height 40px
              background-color #f5f5f5
              padding 0 17px 0 20px
              box-sizing border-box
              position absolute
              top 0
              left 0
              z-index 2
              .scannerr-th-t
                float left
              .icon-add
                float right
                font-size 16px
                margin 12px 0
                cursor pointer
            .scanner-list-li
              display block
              width 100%
              height 40px
              line-height 40px
              padding 0 17px 0 20px
              box-sizing border-box
              &.scanner-list-li-bg
                background-color #f5f5f5
              &.active
                .icon-set
                  display block
              .scanner-name
                float left
                text-align left
                display inline-block
                max-width 100px
                white-space nowrap
                text-overflow ellipsis
                overflow hidden
                vertical-align middle
              .icon-set
                float left
                margin 13px 0 13px 7px
                color #999
                cursor pointer
                display none
                &:hover
                  color #3d3d3d
              .scanner-btn
                float right
                width 64px
                height 20px
                line-height 20px
                font-size 12px
                padding 0
                margin 10px 0
                &.btn-red
                  background-color red
                  width 86px
                  color #fff
            .no-device
              .no-device-main
                img
                  width 47px
          &:hover
            background-color #3d3d3d
            .icon-list
              color #fff
            .scanner-list
              right 0
              -webkit-transition all .5s
              -moz-transition all .5s
              -ms-transition all .5s
              -o-transition all .5s
@keyframes rotate
  0%
    transform rotate(0deg)
  100%
    transform rotate(45deg)
</style>



// WEBPACK FOOTER //
// src/components/Et/ListHead.vue